export function transferRequestCreate() {
    window.user.initCompanyFields("new_office_id", "new_company_id");
}
